import React, { useState, useMemo } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { FileCopySharp } from '@material-ui/icons';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';

//servicios
import { wsFindBy, wsUpdate, wsPost, wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import Button from 'components/CustomButtons/Button.js';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'baseline',
  },
  headerCard: {
    fontSize: '.9em',
    '& .totals': {
      marginLeft: '20px',
      fontWeight: 'bold',
      color: 'black',
    },
  },
  loader: {
    marginLeft: '20px',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo de Cobertura', accessor: 'cobertura_descripcion'},
  { Header: 'Categoria', accessor: 'categoria'},
  { Header: 'Descripción de cuota', accessor: 'description'},
  { Header: 'Cuota', accessor: 'cuota', excelEnabled: false },
  { Header: 'Cuota', accessor: 'cuota_string', hidden: true },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [cuotas, setCuotas] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [valueSearch, setValueSearch] = useState({});
  const [currentCoberturaId, setCurrentCoberturaId] = useState(null); // ID de cobertura seleccionada
  const [isButtonDisabled, setIsButtonDisabled] = useState(true); // Estado del botón


  const handleChange = (id, value) => {
    const index = cuotas.findIndex((item) => item.id == id);
    cuotas[index].cuota = value;
    setCuotas([...cuotas]);
  };

  async function loadCuotas(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/cuota-categoria-colgate',filter);
    setDataLoading(false);
    if (response.success) setCuotas(response.data);
  }
  async function updateCuota(id, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/cuota-categoria-colgate', id, { cuota: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data)
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function transferirRegistros(TargetCoberturaId) {
    setDataLoading(true);
    let response = await wsPost('sale/cuota-categoria-colgate/transferir-registros', {
      TargetCoberturaId: TargetCoberturaId,
    });
    setDataLoading(false);

    if (response.success) {
      showNotify(response.message);
      console.log('Transferencia exitosa: ', response.data);
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
      console.error('Error al transferir registros: ', response);
    }
  }

  const handleFilterChange = (value) => {
    if (value?.id_cobertura) {
      setCurrentCoberturaId(value.id_cobertura); // Actualiza el ID actual
      setIsButtonDisabled(value.id_cobertura <= 1); // Desactiva si no hay un periodo anterior
    } else {
      setCurrentCoberturaId(null); // Resetea si no hay cobertura válida
      setIsButtonDisabled(true);
    }
  };

  const handleTransferClick = () => {
    if (currentCoberturaId) {
      const previousCoberturaId = currentCoberturaId; // Calcula el ID del periodo anterior
      if (previousCoberturaId > 1) {
        transferirRegistros(previousCoberturaId); // Llama con el ID del periodo anterior
      } else {
        showNotify('No hay un periodo anterior válido.', 'warning');
      }
    } else {
      showNotify('Seleccione un periodo para transferir registros.', 'warning');
    }
  };

  const totalCuota = useMemo(() => {
    return cuotas.reduce(
      (acc, item) => acc + parseFloat(item.cuota || 0),
      0
    ).toFixed(2);
  }, [cuotas]);
  
  const formattedTotalCuota = parseFloat(totalCuota).toLocaleString('en-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadCuotas(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <div className={classes.cardIconTitle}>Listado de Cuotas de categoria 
              <div className={classes.headerCard}>
                <span className="totals">Cuota Total: {formattedTotalCuota}</span>
              </div>
              <div className={classes.loader}>
                {dataLoading && <LoadingSpinner />}
              </div>
            </div>
          </CardHeader>
          <CardBody>
          <FilterCustom
            getFilter={loadCuotas}
            getValueSearch={(value) => {
              setValueSearch(value);
              handleFilterChange(value);
            }}
            periodoBimensual
          />
          <Button
            color="danger"
            onClick={handleTransferClick}
          >
            Inicializar cuota de categorias
          </Button>

            <ReactTable
              excelName="cuotas_categoria_colgate"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={cuotas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/cuota-categoria-colgate"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            loadCuotas(valueSearch).then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  cobertura_descripcion: item.cobertura_descripcion,
                  categoria: item.categoria,
                  cuota_string: item.cuota,
                  cuota: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.cuota}
                    >
                      <TextField
                        fullWidth
                        type="text"
                        name="cuota"
                        margin="normal"
                        value={item.cuota || ''}
                        onChange={(e) => handleChange(item.id, e.target.value)}
                        onBlur={(e) => updateCuota(item.id, e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  description: item.description,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
